export default __webpack_public_path__ + "static/media/case_study_6.a0e369dc.jpg";